// Import base react components
import React, {Component, PropTypes} from 'react';
import { DatePicker } from 'components/shared/datePicker'
import { SelectWrapper } from '../../shared/select/SelectWrap'
import { SelectTodoColorWrapper } from '../../shared/select/ColorSelectWrapper'
import moment from 'moment'
import i18n from 'lib/i18n'
import c from 'state/constants'
import styles from '../taskList.scss'

// import tinyMCE. The 5.3 or above also requires importing a theme and a set of icons
import tinymce from 'tinymce/tinymce'
import 'tinymce/icons/default';
import 'tinymce/themes/silver'

// For tinyMCE 5.3 or above, the plugins are now imported here instead of being specified
// as external scripts
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/link'
import 'tinymce/plugins/image'
import 'tinymce/plugins/code'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/visualchars'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/table'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/preview'
// Setup translation group to agenda2
const _ = i18n('agenda2')

/**
 * Task form
 *
 * Handles task create and edit form
 */
export default class TaskForm extends Component {

    /**
	 * Set the required property types for the component
	 */
	static propTypes = {
		formState: React.PropTypes.object.isRequired,
		taskList: React.PropTypes.array,
        selectColorOptions: React.PropTypes.object.isRequired,
        toggleModal: React.PropTypes.func.isRequired,
        createTaskAction: React.PropTypes.func.isRequired,
        editTaskAction: React.PropTypes.func.isRequired,
		formCleanAction: React.PropTypes.func.isRequired,
		setNotificationTypeAction: React.PropTypes.func.isRequired,
    }

    /**
     * Setup constructor with the base state of the component
     * Here we add the default state form task form fields and validation
     */
    constructor(props) {
        super(props)

        this.state = {
			form: {
				title: '',
				description: '',
				date: moment(),
				color: '',
				status: false,
			},
			validation: {
				title: null,
				description: null,
				date: null,
				color: null,
            },
            editor: null,
            staffItems: [],
		}
	}

	/**
	 * Setup component state if the form is in edit state
	 */
	componentWillMount() {
		const { taskId, isEdit } = this.props.formState
		const { taskList, staff } = this.props

		if(isEdit == true)
		{
			taskList.map((value, index) => {
				if(value.id == taskId)
				{
					this.setState({form: {
						title: value.title,
						description: value.description,
						color: value.colorCode,
						date: value.endDate,
						status: value.isCompleted + ""
                    }})
				}
			})
        } else {
            this.setState({
                staffItems: this.generateDataWithoutReference(staff),
            })
        }
    }

    /**
     * On `componentDidMount` event binds the tinyMCE editor to the `textarea` element in the form
     * @see bindTinyMceEditor() the method that bind's the editor to textarea element
     */
    componentDidMount() {
        this.bindTinyMceEditor()
    }


    /**
     * On `componentWillUnmount` event destorys the tinyMCE editor instance binded to `textarea` element
     * @see unbindTinyMceEditors() the method that destroys the editor instances for textarea element
     */
    componentWillUnmount() {
        this.unbindTinyMceEditors()
    }

    /**
     * Binds a tinyMCE editor instance to the textarea element of the task item
     */
    bindTinyMceEditor = () => {
        let editor = this.state.editor
        let elementSelector = `#tinymce-editor`

        window.tinymce.init({
            selector: elementSelector,
            min_height: 365,
            menubar: false,
            mode: "design",
            statusbar: false,

            // [Jancsi] - these are not required anymore for version 5.3+ of tinyMCE, it is enough to specify the teme
            // theme_url: window.location.protocol+'//'+(window.location.href.split("/")[2] + '/themes/modern/theme.js').replace("\/\/", "\/"),
            // skin_url:  window.location.protocol+'//'+(window.location.href.split("/")[2] + '/skins/lightgray/').replace("\/\/", "\/"),
            theme : 'silver',

            toolbar1 : "bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | formatselect fontselect fontsizeselect",
            toolbar2 : "paste pastetext searchreplace | bullist numlist | outdent indent | undo redo | link unlink anchor image code",
            toolbar3 : "forecolor backcolor | table | hr removeformat visualchars | subscript superscript | charmap preview | fullscreen",
            // [Jancsi] these are not required anymore for version 5.3+ of tinyMCE, as plugins are imported at the beginning of the file
            // external_plugins: {
            //     'textcolor': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/textcolor/plugin.js').replace("\/\/", "\/"),
            //     'link': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/link/plugin.js').replace("\/\/", "\/"),
            //     //'image': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/image/plugin.js').replace("\/\/", "\/"),
            //     'code': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/code/plugin.js').replace("\/\/", "\/"),
            //     'searchreplace': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/searchreplace/plugin.js').replace("\/\/", "\/"),
            //     'paste': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/paste/plugin.js').replace("\/\/", "\/"),
            //     'visualchars': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/visualchars/plugin.js').replace("\/\/", "\/"),
            //     'charmap': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/charmap/plugin.js').replace("\/\/", "\/"),
            //     'table': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/table/plugin.js').replace("\/\/", "\/"),
            //     'fullscreen': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/fullscreen/plugin.js').replace("\/\/", "\/"),
            //     'preview': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/preview/plugin.js').replace("\/\/", "\/"),
            // },
            plugins : ["textcolor link code searchreplace paste visualchars charmap table fullscreen preview"],
            force_br_newlines: false,
            force_p_newlines: false,
            forced_root_block: "",
            relative_urls: false,
            remove_script_host: false,
            convert_urls: true,
            setup: editorInstance => {
                editor = editorInstance
                editorInstance.on('init', (e) => {
                    this.initializeBodyEditor(editorInstance)
                })

                this.setState({ editor: editor })
            }
        })
    }

    /**
     * Initialize an editor instance body
     * @param {object} editorInstance the tinyMCE editor instance
     * @param {int} taskItemKey the taskItem key
     */
    initializeBodyEditor = ( editorInstance ) => {
        let { form } = this.state

        if( window.tinymce && editorInstance ) {

            try {
                editorInstance.setContent(form.description, {format: 'raw'})
            } catch(exc) {
                console.log(exc)
            }

            editorInstance.on('blur', (e) => {
                this.handleDescriptionChange(editorInstance.getContent())
            })

            editorInstance.on('click', (e) => {
                this.handleDescriptionChange(editorInstance.getContent())
            })
        }
    }

    /**
     * Unbinds the tinyMCE editor for the element in the state.editor
     */
    unbindTinyMceEditors = () => {
        window.tinymce.execCommand("mceFocus", true, 'tinymce-editor')
        window.tinymce.execCommand("mceRemoveEditor", true, 'tinymce-editor')
        window.tinymce.execCommand("mceRemoveControl", false, 'tinymce-editor')
    }

	getTaskRelationsList() {
		const { taskId, isEdit } = this.props.formState
		const { taskList } = this.props

		let taskRelations = []

		if(isEdit == true) {
			taskList.map((value, index) => {
				if(value.id == taskId) {
					taskRelations = value.relations
				}
			})
		}

		return taskRelations
    }

    /**
     * This function give back the selected tsk from the list by id from state.
     */
    getOpenedTask() {
        const { taskId, isEdit } = this.props.formState
        const { taskList } = this.props
        let task = false

        // the id exists only in case when editing is true. Tha same react module is used for handling tasks.
        if(isEdit == true) {
            taskList.map((value, index) => {
                if(value.id == taskId) {
                    task = value
                }
            })
        }
        return task
    }

    getTaskReceivedList() {
        const { taskId, isEdit } = this.props.formState
        const { taskList } = this.props
        let taskRelations = []

        if (isEdit === false) {
            return (
                <div>
                    {_('receivedTasks')} /
                </div>
            )
        }

/*         if (isEdit !== true) {
            return
        } */

        let taskReceivedData
        let taskUserRelational = null
        let taskTitle = null
        let isEmpty = ""
        let theTask = {}

        taskList.map((value, index) => {
            if(value.id === taskId) {
                taskReceivedData = value.receivedFrom
                theTask = value
                //taskUserRelational = value.userRelation
                //taskTitle = value.title
            }
        })

        if(taskReceivedData.ticket.length < 1 && taskReceivedData.task.length < 1/*  && !theTask.ticketReferral */)  {
            isEmpty = '/'
        }

        return (
            <div key={"getTaskReceivedList_container_"+taskId}>
                {_('receivedTasks')} {isEmpty}
                <div className={"results"} key={"taskReceivedData_"+taskId}>
                    {taskReceivedData && taskReceivedData.ticket && taskReceivedData.ticket.length ?
                    taskReceivedData.ticket.map((ticketItem, key) => {
                        return <span>{_('ticket')} - {this.getStaffName(ticketItem.userId)} - {ticketItem.ticketDescription}</span>
                    }) : null
                    }
                    {theTask && theTask.ticketReferral && (!taskReceivedData.ticket || taskReceivedData.ticket.length == 0) ?
                        <div>
                            {_("missingTicketRelation")}
                        </div>
                        : null
                    }
                </div>


                <div className={"results"}
                    key={"taskReceivedData_task_"+taskId}>
                    {taskReceivedData && taskReceivedData.task && taskReceivedData.task.length > 0
                    ? taskReceivedData.task.map((taskItem, key) => {
                        return <span>{_('task')} - {this.getStaffName(taskItem.userId)} - {this.getTaskStatus(taskItem.isCompleted)} - {taskItem.title}</span>
                    }) : null}
                    {/*
                    {taskUserRelational !== undefined && taskUserRelational !== null &&
                        <span>{_('task')} - {this.getStaffName(taskUserRelational) } - { taskTitle}</span>
                    }*/}
                    {theTask && theTask.taskRelation && (!taskReceivedData.task || taskReceivedData.task.length == 0) ?
                        <div>
                            {_("missingTaskRelation")}
                        </div>
                        : null
                    }
                </div>

                <div className={taskReceivedData.email.length ? "results" : "noresults"}  key={"taskReceivedData_email_"+taskId}>
                    {taskReceivedData && taskReceivedData.email && taskReceivedData.email.length && taskReceivedData.email.map((emailItem, key) => {
                        return <span>{_('email')} - {this.getStaffName(emailItem.userId)} - {emailItem.subject}</span>
                    })}
                </div>
            </div>
        )
    }

    /**
     * Returns the current task documents list in html format
     */
    getTaskDocumentsList() {
        const { taskId, isEdit } = this.props.formState
        const { taskList } = this.props

        let itemData = null

        if(isEdit == true) {
            taskList.map((value, index) => {
                if(value.id == taskId) {
                    itemData = value
                }
            })
        }

        if (itemData === null) {
            return
        }

        if (itemData.ticketDocuments === undefined || itemData.ticketDocuments === null) {
            return
        }

        return (
                <div className={styles.documentsWrapper}>
                    <h2>{_('documents')}</h2>
                    <div className={styles.documents}>
                        {itemData.ticketDocuments && itemData.ticketDocuments.map((doc, key) =>
                            <a
                                key={key}
                                href={`/data/document?id=${doc}&type=${itemData.ticketDoctype}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {doc}
                            </a>
                        )}
                    </div>
                </div>
        )
    }

	/**
	 * Get the staff name based on user id
	 *
	 * @param {string} userId the staff user unique id
	 */
	getStaffName(userId) {
		const { staff } = this.props

		let name = '-'

		staff.forEach(element => {
			if(element.userId == userId) {
				name = element.firstName + ' ' + element.lastName
			}
		})

		return name
	}

	/**
	 * Return the status string based on task isCompleted value
	 *
	 * @param {boolean} status
	 */
	getTaskStatus(status) {
		if(status == true) {
			return _('completed')
		} else {
			return _('uncompleted')
		}
	}

    /**
	 * Handle color change
	 */
	handleColorChange(event) {
        let { form } = this.state
        const { toggleModal, setNotificationTypeAction } = this.props

		if(event.value == 'manage')
		{
            toggleModal(c.TASK_MODULE_MODAL_NAME_MANAGE_COLORS)
			return;
		}

		if(event.value == 'create')
		{
			toggleModal(c.TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER)
			return;
		}

		if(event.value == 'reset')
		{
			setNotificationTypeAction('resetColors')
			return;
		}

		form.color = event.value
		this.setState({form: form});
    }

    /**
     * Handle title change
     */
    handleTitleChange(event)
	{
		let {form} = this.state
		form.title = event.target.value

		this.setState({form: form})
	}

    /**
     * Handle date change
     */
	handleDateChange(event)
	{
		let {form} = this.state
		form.date = event

        let newDate = moment(event).set({hour: 1}).format('YYYY-MM-DD h:mm:ss')
		this.setState({form: form})
	}

    /**
     * Handle description change
     */
	handleDescriptionChange(value)
	{
		let {form} = this.state
		form.description = value

		this.setState({form: form})
	}

	/**
	 * Handle status change
	 */
	handleStatusChange(event)
	{
		let { form } = this.state
		form.status =event.value

		this.setState({form: form})
	}

    /**
     * Handles submit if the validation was ok
     */
    handleSubmit(event)
    {
        const { form, staffItems } = this.state
		const { formState, createTaskAction, editTaskAction, taskCreatorGenerateWithRelations } = this.props

        // Clean the validation on every submit
		this.setState({
            validation: {
				title: null,
				description: null,
				date: null,
				color: null,
            }
        })

        // If validation was true then create task
		if(this.validate())
		{
			if(formState.isEdit == false)
			{
                taskCreatorGenerateWithRelations({
                    items: [
                        {
                            title: form.title,
                            description: form.description,
                            endDate: form.date,
                            isCompleted: form.status,
                            colorCode: form.color
                        }
                    ],
                    users: staffItems,
                    isArchiveConfirmation: false,
                    convertionType: 'taskCreate'
                })
			}
			else
			{
				form.id = formState.taskId
				editTaskAction(form)
			}
		}
    }

    /**
     * Generate a new array of data object without reference to the array of objects
     * @param {array} items the array of objects
     * @return {array} the new array object without reference
     */
    generateDataWithoutReference = ( items ) => {
        const { userId } = this.props
        let newArray = []

        items.map((itemValue, itemKey) => {
            let newItem = JSON.parse(JSON.stringify(itemValue));

            /**if(newItem.userId === userId) {
                newItem.selected = true;
            }**/

            newArray[itemKey] = newItem;
        })

        return newArray
    }

    /**
     * Toggles a staff item selected property based on `staffId`
     * @param {int} staffId the id of the staff item `userId` property in the staff shape
     */
    staffItemSelectionHandler = staffId => {
        let staffItems = this.state.staffItems
        let selection = []

        staffItems.map((value, key) => {
            selection[key] = { ...value }

            if (value.userId == staffId) {
                selection[key].selected = !value.selected
            }
        })

        this.setState({ staffItems: selection })
    }

    /**
     * Validate form after submit to check if required fields are ok
     */
	validate()
	{
		let { form, validation } = this.state
		let invalidFields = false;

		if(form.title == '' || form.title == null)
		{
			validation.title = _('requiredField')
			invalidFields = true
		}

		if(form.description == '' || form.description == null)
		{
			validation.description = _('requiredField')
			invalidFields = true
		}

		if(invalidFields == true)
		{
			this.setState({validation: validation})
			return false;
		}
		else
		{
			return true;
		}
    }

    /**
     * Render
     * Handles the render part for the component
     */
    render() {
        const {title, description, date, color, status } = this.state.form
        const { validation } = this.state
        const staffItems = this.state.staffItems
        const { formState, selectColorOptions, toggleModal, formCleanAction, staff } = this.props

        let canSubmitForm = true


        if (formState.isEdit == false ) {
            canSubmitForm = staffItems.reduce((a, b) => a + (b.selected ? 1 : 0), 0);
        }


        // Select color actions
        let selectColorActions = [
			{
                value: 'manage',
                label: _("manageColors"),
                colorCode: null
			},
        ]

		if(selectColorOptions.userColors.length < 15)
		{
			selectColorActions.push({
                value: 'create',
                label: _("newColor"),
                colorCode: null
            })
		}

		if(selectColorOptions.userColors.length > 0)
		{
			selectColorActions.push({
                value: 'reset',
                label: _("resetColors"),
                colorCode: null
            })
		}

        // Define select options for select todo color
		const selectTodoColor = [
			{
				value: '',
				label: _('noTodoColor'),
				colorCode: null
			},
			...selectColorOptions.defaultColors,
			...selectColorOptions.userColors,
			...selectColorActions
		]

		let startDate 	= moment().subtract(1,'day').format('YYYY-MM-DD h:mm:ss')
		let endDate 	= moment().add(10,'years').format('YYYY-MM-DD')

		const statusOptions = [
			{
				value: "true",
				label: _('statusCompleted')
			},
			{
				value: "false",
				label: _('statusUncompleted')
			}
		]

		let submitButtonText = (formState.isEdit == true) ? 'edit' : 'createTodo'
        let taskRelationsList = this.getTaskRelationsList()
        // get task in case when editing is active, else will be false
        let theTask = this.getOpenedTask()

		return (
			<div className={styles.todoModalContent} key={"TaskFormModalContent"}>
				{ formState.isEdit == true && <span className={styles.title} key={"isEditSpanKey1"}>{_("editTodo")}</span> }
				{ formState.isEdit == false && <span className={styles.title} key={"isEditSpanKey2"}>{_("addTodo")}</span> }


                <div className={styles.subContentWrapper} key={"TaskFormSubContentWrapper"}>
                    <label>{_('title')} *</label>
                    <input
                        type="text"
                        onChange={(ev) => this.handleTitleChange(ev)}
                        value={title}
                    />
                    <div className={ styles.error }> {validation.title != null && validation.title } </div>

                    <div className={styles.datepickerFlexRow} key={"datePickerFlexRow"}>
                        <div className={styles.datepickerLabelField}>
                            <label>{_('todoDate')} *</label>
                            <DatePicker
                                onChange={(ev) => this.handleDateChange(ev)}
                                value={date}
                                maxDate={endDate}
                            />
                        </div>

                        <div className={styles.datepickerLabelField}>
                            <label>{_('color')}</label>
                            <SelectTodoColorWrapper
                                options={selectTodoColor} value={color}
                                onChange={this.handleColorChange.bind(this)}
                            />
                        </div>
                    </div>

                    <label>{_('description')} *</label>
                    <textarea id="tinymce-editor"/>
                    <div className={ styles.error }> {validation.description != null && validation.description } </div>

                    { formState.isEdit == true && <label>{_('status')}</label>}
                    { formState.isEdit == true &&
                        <SelectWrapper
                            value={status}
                            options={statusOptions}
                            onChange={(ev) => this.handleStatusChange(ev)}
                        />
                    }
                </div>

				{/*#list [staffItems]*/}
                { formState.isEdit != true && <div className={styles.modalSubtitle}>{_("selectUsers")}</div> }
                { formState.isEdit != true &&
                    <ul className={styles.staffItemsList}>
                        {staffItems.map((staffItem, key) => (
                            <li
                                key={staffItem.userId}
                                data-selected={staffItem.selected}
                                onClick={() => this.staffItemSelectionHandler(staffItem.userId)}
                            >
                                <span key={"staffItemKeyFirstName"}>
                                    {staffItem.firstName + " " + staffItem.lastName}
                                </span>

                                <span key={"staffItemKeyEmail"}>{staffItem.email}</span>
                            </li>
                        ))}
                    </ul>
                }
                {/*endlist*/}

                { formState.isEdit == true &&
                    <div className={styles.subContentWrapper} key={"subContentWrapperIsEditKey"}>
                        {this.getTaskDocumentsList()}

                        <div className={styles.relatedTasks}>
                            {_('sentTasks')} {taskRelationsList.length < 1 && '/'}
                            {taskRelationsList.map((itemData,key) => {
                                return <span key={"getTaskRelationsListItemData"+key}>{this.getStaffName(itemData.userId)} - {this.getTaskStatus(itemData.isCompleted)} - {itemData.title}</span>
                            })}
                        </div>

                        <div className={styles.relatedTasks}>
                            {this.getTaskReceivedList()}
                        </div>

                        <div className={ styles.formError }>
                            {formState.status == false && formState.message }
                        </div>
                    </div>
                }

				<div className={styles.todoModalButtons} key={"todoModalButtonsTaskKeyLast"}>
					<span
						onClick={() => {
                            toggleModal(c.TASK_MODULE_MODAL_NAME_MANAGE_TASK)
                            formCleanAction('manageTask')
                        }}
						className={styles.cancel}
					>
						{_("cancel")}
					</span>
					<input
						onClick={(event) => this.handleSubmit(event)}
						type="button"
						className={styles.greyButton}
                        value={_(submitButtonText)}
                        disabled={!canSubmitForm}
					/>
				</div>
			</div>
		)
    }

}



// WEBPACK FOOTER //
// ./components/taskList/components/taskForm.jsx